import { mapActions } from 'vuex';
import loaderMixin from '@/mixins/loader';
import cmsContentMixin from '@/mixins/cmsContent';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { formMixin } from '@/components/forms/mixin';

const TOTAL_COLUMNS = 12;
const COLUMN_OPTIONS = [
  { label: '0%', value: 0 },
  { label: '8.3%', value: 1 },
  { label: '16.6%', value: 2 },
  { label: '25%', value: 3 },
  { label: '33.3%', value: 4 },
  { label: '41.6%', value: 5 },
  { label: '50%', value: 6 },
  { label: '58.3%', value: 7 },
  { label: '66.6%', value: 8 },
  { label: '75%', value: 9 },
  { label: '83%', value: 10 },
  { label: '91.6%', value: 11 },
];
const TYPE_OPTIONS = [
  { label: 'Desktop', value: 'desktop' },
  { label: 'Mobile', value: 'mobile' },
  { label: 'Detail', value: 'detail' },
];
export default {
  mixins: [
    cmsContentMixin,
    formMixin,
    loaderMixin,
  ],
  props: {
    previewId: {},
  },
  data() {
    return {
      COLUMN_OPTIONS,
      TYPE_OPTIONS,
      typeChoice: TYPE_OPTIONS[0],
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0],
      },
    };
  },
  components: {
    alertBox,
  },
  computed: {
    classModifiers() {
      return {
        'page-story-preview': true,
        [`page-story-preview--${this.typeChoice.value}`]: true,
      };
    },
    isColumnCountExceeding() {
      return (this.columnChoice.left.value + this.columnChoice.right.value) >= TOTAL_COLUMNS;
    },
    middleOption() {
      const sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses() {
      const option = this.columnChoice.left.value;
      return {
        column: true,
        [`small-${option}`]: !!option,
      };
    },
    middleColumnClasses() {
      return {
        column: true,
        [`small-${this.middleOption}`]: !!this.middleOption,
      };
    },
    rightColumnClasses() {
      const option = this.columnChoice.right.value;
      return {
        column: true,
        [option]: !!option,
      };
    },
  },
  methods: {
    ...mapActions('browse', ['getStoryFullPreview']),
    typeChoiceHandler(option) {
      switch (option.value) {
        case 'mobile':
          this.columnChoice.left = COLUMN_OPTIONS[4];
          this.columnChoice.right = COLUMN_OPTIONS[4];
          break;
        case 'desktop':
          this.columnChoice.left = COLUMN_OPTIONS[1];
          this.columnChoice.right = COLUMN_OPTIONS[1];
          break;
        case 'detail':
          this.columnChoice.left = COLUMN_OPTIONS[0];
          this.columnChoice.right = COLUMN_OPTIONS[0];
          break;
        default:
          break;
      }
      this.loaderAdd(document.body);
      this.getStoryFullPreview(this.previewId)
        .then((responseData) => {
          let data = {};
          switch (option.value) {
            case 'mobile':
              data = {
                renderedHTML: responseData.homePagePreviewViewModel.mobileContent.html,
                cmsContentObject: responseData.homePagePreviewViewModel.mobileContent.cmsContent,
              };
              break;
            case 'desktop':
              data = {
                renderedHTML: responseData.homePagePreviewViewModel.desktopContent.html,
                cmsContentObject: responseData.homePagePreviewViewModel.desktopContent.cmsContent,
              };
              break;
            case 'detail':
              data = {
                renderedHTML: responseData.detailPageViewModel.bodyHTML,
                cmsContentObject: responseData.detailPageViewModel.cmsContentObject,
              };
              break;
            default:
              break;
          }
          this.loaderRemove(document.body);
          this.installDynamicControls({ data });
        })
        .catch(() => this.loaderRemove(document.body));
    },
  },
  watch: {
    typeChoice: {
      handler: 'typeChoiceHandler',
      immediate: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-story-preview/page-story-preview.js